import React from "react";
import AccordionComponent from "./forms/AccordionComponent";
import LinkSessionComponent from "./LinkSession/LinkSessionComponent";
import useAccordion from "../hooks/useAccordion";
import useLogin from "@common/components/hooks/useLogin";
import LinkedAlerts from "./LinkedAlerts";

const AlertsAndSessions = () => {
  const { activeAccordionIndex, setAccordionIndex } = useAccordion();
  const [{ optionDisplaySessionsInCompliance, optionShowComplianceAlerts }] =
    useLogin();
  const panes = [];

  if (optionDisplaySessionsInCompliance) {
    panes.push({
      title: "Sessions Summary",
      component: LinkSessionComponent,
    });
  }

  if (optionShowComplianceAlerts) {
    panes.push({ title: "Alerts Summary", component: LinkedAlerts });
  }

  if (panes.length < 1) {
    return <></>;
  }

  return (
    <div className="pb-1">
      <AccordionComponent
        contentClassName="pb-1"
        contents={panes}
        activeIndex={activeAccordionIndex}
        setActiveIndex={(value) => setAccordionIndex(value)}
      />
    </div>
  );
};

export default AlertsAndSessions;
